export const WEEK_CALENDAR_MODAL_EVENT = 'modals:week-calendar';
export const WEEK_CALENDAR_MODAL_OPEN = `${WEEK_CALENDAR_MODAL_EVENT}:open`;
export const WEEK_CALENDAR_MODAL_CLOSE = `${WEEK_CALENDAR_MODAL_EVENT}:close`;
